import React from "react";
import Home from "./pages/Home/Home";
import { Routes, Route, useLocation } from "react-router-dom";
import Bio from "./pages/Bio/Bio";
import CV from "./pages/CV/CV";
import Portfolio from "./pages/Portfolio/Portfolio";
import Blogs from "./pages/Blogs/Blogs";
import PeregrineBlogs from "./pages/Blogs/PeregrineBlogs";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { AnimatePresence } from "framer-motion";
import "./App.css";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/Bio" element={<Bio />} />
          <Route path="/CV" element={<CV />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/Blogs/Peregrine" element={<PeregrineBlogs />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
